import { useSyncExternalStore } from 'react'
import type { DesignElementType } from '@/types/blocks'

/**
 * Примерка элемента составного блока: панель (`ElementPalette`) сообщает, на
 * какой тип наведена мышь, холст (`DesignCanvas`) дорисовывает полупрозрачный
 * элемент этого типа в конец экрана. Ничего не пишет в черновик — только показ.
 */
let hovered: DesignElementType | null = null
const listeners = new Set<() => void>()

/**
 * Снятие примерки — с задержкой: между строками списка есть зазор, и мышь,
 * переходя со строки на строку, на миг уходила с обеих — холст мелькал пустым
 * состоянием блока. Наведение на следующую строку отменяет снятие.
 */
const CLEAR_DELAY_MS = 120
let clearTimer: ReturnType<typeof setTimeout> | null = null

const apply = (next: DesignElementType | null) => {
  if (hovered === next) return
  hovered = next
  listeners.forEach((l) => l())
}

export const setHoveredDesignElement = (next: DesignElementType | null): void => {
  if (clearTimer) {
    clearTimeout(clearTimer)
    clearTimer = null
  }
  if (next !== null) {
    apply(next)
    return
  }
  clearTimer = setTimeout(() => {
    clearTimer = null
    apply(null)
  }, CLEAR_DELAY_MS)
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const useHoveredDesignElement = (): DesignElementType | null =>
  useSyncExternalStore(subscribe, () => hovered)
